import { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthFuseGuard } from '../../../shared/src/lib/guard/authFuse.guard';
import { NoAuthFuseGuard } from '../../../shared/src/lib/guard/noAuthFuse.guard';
import { MaintenanceGuard } from '../../../shared/src/lib/guard/maintenance.guard';
import { MissingInformationGuard } from '../../../shared/src/lib/guard/missingInformation.guard';
import { StudentInitialDataResolver } from './student.resolvers';
import { NoAuthTranslationResolver } from './no-auth.resolvers';


export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: '',
    component: LayoutComponent,
    resolve: { translations: NoAuthTranslationResolver },
    canActivate: [NoAuthFuseGuard, MaintenanceGuard],
    loadChildren: () => import('./pages/auth/auth.routes').then(m => m.authRoutes),
    data: { layout: 'empty' }
  },
  {
    path: '',
    component: LayoutComponent,
    resolve: { initialData: StudentInitialDataResolver },
    canActivate: [AuthFuseGuard, MaintenanceGuard],
    canActivateChild: [MissingInformationGuard],
    children: [
      { path: 'dashboard', loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent) },
      { path: 'formations', loadChildren: () => import('./pages/formations/formations.routes').then(m => m.formationsRoutes) },
      { path: 'sessions', loadChildren: () => import('./pages/sessions/sessions.routes').then(m => m.sessionsRoutes) },
      { path: 'progression', loadChildren: () => import('./pages/progression/progression.routes') },
      { path: 'messages', loadChildren: () => import('./pages/messages/messages.routes').then(m => m.messagesRoutes) },
      { path: 'sheets', loadChildren: () => import('./pages/sheets/sheets.routes') },
      { path: 'exercices', loadChildren: () => import('./pages/exercices/exercices.routes') },
      { path: 'documents', loadChildren: () => import('./pages/documents/documents.routes') },
      { path: 'homework', loadChildren: () => import('./pages/homework/homework.routes') },
      { path: 'profile', loadChildren: () => import('./pages/profile/profile.routes') },
      { path: 'edit-schedule', loadChildren: () => import('./pages/edit-schedule/edit-schedule.routes').then(m => m.editScheduleRoutes) },
      { path: 'booking-lilate-formation', loadComponent: () => import('./pages/booking-lilate-formation/booking-lilate-formation.component').then(m => m.BookingLilateFormationComponent) },
      { path: 'satisfaction-survey', loadComponent: () => import('./pages/satisfaction-survey/satisfaction-survey.component').then(m => m.SatisfactionSurveyComponent) },
      { path: 'missing-information', loadComponent: () => import('./pages/missing-information/missing-information.component').then(m => m.MissingInformationComponent) },
      {
        path: 'edit-targeted-level/:id',
        loadComponent: () => import('./pages/edit-targeted-level/edit-targeted-level.component').then(m => m.EditTargetedLevelComponent)
      },
    ]
  },

  {
    path: '',
    component: LayoutComponent,
    resolve: { initialData: StudentInitialDataResolver },
    canActivate: [AuthFuseGuard, MaintenanceGuard],
    children: [
      { path: 'plan-formation', loadChildren: () => import('./pages/plan-formation/plan-formation.routes'), data: { layout: 'empty' } },
    ]
  },

  { path: 'maintenance', loadComponent: () => import('../../../shared/src/lib/feature-fuse/maintenance-fuse/maintenance-fuse.component').then(m => m.MaintenanceFuseComponent), data: { layout: 'empty' } },
  { path: '**', loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent), data: { layout: 'empty' } }
];

